import { createTheme } from '@mui/material/styles';
import { deDE } from '@mui/material/locale';

// Light Mode Theme
const lightTheme = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: '#00695C', // Dunkleres Teal als Akzentfarbe
        light: '#439889', // Helleres Teal
        dark: '#003D33', // Sehr dunkles Teal
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#FF7043', // Kräftiger Coral-Ton als Kontrast zu Teal
        light: '#FF8A65', // Hellerer Coral-Ton
        dark: '#D84315', // Dunklerer Coral-Ton
        contrastText: '#FFFFFF',
      },
      background: {
        default: '#F6F6F6',
        paper: '#FFFFFF',
      },
      error: {
        main: '#B00020',
        light: '#CF6679',
        dark: '#8C0009',
        contrastText: '#FFFFFF',
      },
      warning: {
        main: '#FF9800',
        light: '#FFB74D',
        dark: '#C66900',
        contrastText: '#000000',
      },
      info: {
        main: '#0288D1',
        light: '#5EB8FF',
        dark: '#005B9F',
        contrastText: '#FFFFFF',
      },
      success: {
        main: '#4CAF50',
        light: '#80E27E',
        dark: '#087F23',
        contrastText: '#FFFFFF',
      },
      text: {
        primary: '#212121',
        secondary: '#757575',
        disabled: '#9E9E9E',
      },
      divider: 'rgba(0, 0, 0, 0.12)',
    },
    typography: {
      fontFamily: ['"Roboto"', 'sans-serif'].join(','),
      h1: {
        fontSize: '2rem',
        fontWeight: 700,
      },
      h2: {
        fontSize: '1.5rem',
        fontWeight: 600,
      },
      body1: {
        fontSize: '1rem',
      },
      button: {
        textTransform: 'none',
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 8,
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
    },
  },
  deDE
);

// Dark Mode Theme
const darkTheme = createTheme(
  {
    palette: {
      mode: 'dark',
      primary: {
        main: '#00A896', // Helleres Teal als Akzentfarbe (war #00695C)
        light: '#5ED4C2', // Helleres Teal (war #439889)
        dark: '#007E6E', // Helleres dunkles Teal (war #003D33)
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#FF7043', // Kräftiger Coral-Ton als Kontrast zu Teal
        light: '#FF8A65', // Hellerer Coral-Ton
        dark: '#D84315', // Dunklerer Coral-Ton
        contrastText: '#FFFFFF',
      },
      background: {
        default: '#121212',
        paper: '#1E1E1E',
      },
      error: {
        main: '#CF6679',
        light: '#FF8A9A',
        dark: '#9A4554',
        contrastText: '#000000',
      },
      warning: {
        main: '#FF9800',
        light: '#FFB74D',
        dark: '#C66900',
        contrastText: '#000000',
      },
      info: {
        main: '#29B6F6',
        light: '#73E8FF',
        dark: '#0086C3',
        contrastText: '#000000',
      },
      success: {
        main: '#4CAF50',
        light: '#80E27E',
        dark: '#087F23',
        contrastText: '#000000',
      },
      text: {
        primary: '#FFFFFF',
        secondary: '#B0B0B0',
        disabled: '#757575',
      },
      divider: 'rgba(255, 255, 255, 0.12)',
    },
    typography: {
      fontFamily: ['"Roboto"', 'sans-serif'].join(','),
      h1: {
        fontSize: '2rem',
        fontWeight: 700,
      },
      h2: {
        fontSize: '1.5rem',
        fontWeight: 600,
      },
      body1: {
        fontSize: '1rem',
      },
      button: {
        textTransform: 'none',
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 8,
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
    },
  },
  deDE
);

export { lightTheme, darkTheme };
